import $api from 'http'
import $apiJSON from 'http/apiJSON'

export const getCurrentUser = authorization => $apiJSON.get('account/me/', authorization ? { erpAuthStep: true, headers: { Authorization: 'Bearer ' + authorization } } : {})
export const loginWithPassword = (username, password) => $apiJSON.post('account/token/standard/', { username, password })
export const verifyLoginPin = (pin, userId, token) => $apiJSON.post('employees/checkpin/', { pin, user_id: userId }, { erpAuthStep: true, headers: { Authorization: 'Bearer ' + token } })
export const enrollLoginPin = (pin, token, confirmation = pin) => $apiJSON.patch('employees/change-pin/', { new_pin: pin, new_pin_confirm: confirmation }, { erpAuthStep: true, headers: { Authorization: 'Bearer ' + token } })

//API для авторизации

export async function login(email) {
  return $apiJSON.post('account/token/', { username: email })
}

export async function logintrash(emailtrash, passwordtrash) {
  return $apiJSON.post('account/token/', {
    username: emailtrash,
    password: passwordtrash,
  })
}

//API вход через почту (не работает)

export async function postToMail(email) {
  return $api.post(`/account/emailauth/`, { email })
}
//API для сброса пароля
export async function postRecoverPassword(inn) {
  return $api.post(`/account/recoverpassword/`, { inn })
}
export async function postRecoverPasswordCheckPin(recoverCode, inn) {
  return $api.post(`/account/recoverpassword/`, { recoverCode, inn })
}

export async function postRecoverPasswordEndProgress(password, inn) {
  return $api.post(`/account/recoverpassword/`, { password, inn })
}
export async function postRecoverPin(recoverPin, inn) {
  return $api.post(`/account/recoverpassword/`, { recoverPin, inn })
}

export async function postRecoverPinCheckPin(recoverPinCode, inn) {
  return $api.post(`/account/recoverpassword/`, { recoverPinCode, inn })
}
//API для получения информации пользователя

export async function getUserInfo(id) {
  return $apiJSON.get(`employees/employee/${id}/`)
}

export async function postUserInfo(id, data) {
  return $apiJSON.post(`employees/employee/${id}/`, data)
}

export async function getPersonInfo(id) {
  return $apiJSON.get(`employees/employeeone/${id}/`)
}
export async function getEmailDatacor(emails) {
  return $apiJSON.get(`account/emaillol/${emails}/`)
}
export async function getWidgetInfo(id) {
  return $apiJSON.get(`task-app-count/${id}/`)
}

export async function getUserId(data) {
  return $api.get('/employees/userid/', data)
}
//API для изменения профиля пользователя

export async function ChangeProfileImage(imeag) {
  return $api.patch(`employees/profimage/`, { imeag })
}

export async function ChangePassword(new_password) {
  return $apiJSON.patch(`employees/change-password/`, { new_password })
}

export async function ChangePin(pin) {
  return $apiJSON.patch(`employees/change-pin/`, { pin })
}

export async function SendQuizAnswers(data) {
  return $apiJSON.post(`/answer/`, data)
}



export async function ChangeProfileNumber(number_phone) {
  return $api.patch(`employees/profimage/`, { number_phone })
}
export async function ChangeProfileEmail(email) {
  return $api.patch(`employees/profimage/`, { email })
}

export async function checkPinCode(pinCode, userId) {
  return $api.post(`employees/checkpin/`, { pin: pinCode, user_id: userId });
}

